export const datasource = 'gitlab-packages';
